import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import washService from "../../../services/wash.service";
import { IWashRequest } from "../../../types/wash.types";
import WashHistoryTable from "../../../components/WashHistoryTable/WashHistoryTable";

interface CustomerWashingHistoryProps {
  userId: string;
  name?: string;
}

const CustomerWashingHistory = ({ userId, name }: CustomerWashingHistoryProps) => {
  const { t } = useTranslation();
  const [washes, setWashes] = useState<IWashRequest[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!userId) return;
    setLoading(true);
    setError(null);
    washService
      .getUserWashes(userId)
      .then((data) => setWashes(data))
      .catch((err: any) => setError(err.message || t("washingHistory.loadFailed")))
      .finally(() => setLoading(false));
    // Re-runs only when userId changes; `t` changes identity on
    // language switch, and re-running this fetch because the UI language
    // changed is not wanted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  return (
    <Box p={3}>
      <WashHistoryTable
        washes={washes}
        loading={loading}
        error={error}
        onDismissError={() => setError(null)}
        title={t("washingHistory.customerTitle", { name: name ?? "" })}
        emptyMessage={t("washingHistory.emptyForCustomer")}
        showCarWash
        showEmployee
      />
    </Box>
  );
};

export default CustomerWashingHistory;
